<div class="outputType__header">
  {{ 'output_type' | ppTranslate }}
</div>

<pp-select
  [ppItems]="outputTypes"
  [ppSelectedItem]="outputTypes[outputTypeIndex]"
  (ppSelectItem)="selectItem($event)"
  [ppNoSearchBar]="true"
  [ppIsModal]="true"
  require
  >
  <ng-container selected>
    @if (outputTypeIndex !== -1) {
      <span class="formulaOutputPicker__option">
        {{ outputTypes[outputTypeIndex].label }}
      </span>
    }

    @if (outputTypeIndex === -1) {
      <span class="formulaOutputPicker__placeholder">
        {{ 'choose_formula_output_type' | ppTranslate }}
      </span>
    }
  </ng-container>
</pp-select>
